import { App } from './app.class';

export class Modal {

    // Initialisieren
    constructor(selector) {

        if(typeof selector === 'object')
            this.$ele = selector;
        else
            this.$ele = document.querySelector(selector);
    }

    // Einblenden
    show() {
        this.$ele.classList.remove('invisible');
        this.$ele.classList.remove('closed');

        // Focus auf erstes Eingabefeld oder Button setzen
        const $input = this.$ele.querySelector('input[type=text],input[type=email],input[type=url],input[type=tel],select,textarea');
        const $btn = this.$ele.querySelector('.btn-primary');
        if($input) {
            setTimeout(() => {
                $input.focus();
            }, 300);
        }
        else if($btn) {
            setTimeout(() => {
                $btn.focus();
            }, 300);
        }
    }

    // Ausblenden
    close() {
        this.$ele.classList.add('closed');
        setTimeout(() => { this.$ele.classList.add('invisible'); }, 300);
    }
}

// Initialisierung wenn DOM geladen
App.domready(function(){

    // Klick-Event
    document.addEventListener('click', event => {

        // Klicks zum Öffnen
        if(event.target && event.target.closest('*[data-modal-show]')) {
            const $btn = event.target.closest('*[data-modal-show]');
            const id = $btn.getAttribute('data-modal-show');
            if(id !== '')
                new Modal('#'+id).show();
        }

        // Klicks zum Schliessen
        if(event.target && event.target.closest('*[data-modal-close]')) {
            const $btn = event.target.closest('*[data-modal-close]');
            const id = $btn.getAttribute('data-modal-close');
            if(id === '' || id === null) {
                const $modal = $btn.closest('.modal');
                if($modal !== null) {
                    new Modal($modal).close();
                }
            }
            else if(id !== '')
                new Modal('#'+id).close();
        }

        // Klick auf Overlay
        if(event.target && event.target.matches('.overlay > div')) {
            const $modal = event.target.closest('.modal');
            if($modal !== null && $modal.classList.contains("modal") && $modal.classList.contains("close-with-overlay")) {
                new Modal($modal).close();
            }
        }

    });

    // Esc-Taste zum Schliessen
    document.addEventListener("keyup", event => {
        if(event.key === "Escape") {

            // Photoswipe-Ansicht ist geöffnet > Modals nicht schliessen
            if(document.querySelector(".pswp.pswp--open")) {
                return;
            }

            // Modals schliessen
            const modalClsEsc = document.querySelectorAll('.modal.close-with-esc');
            modalClsEsc.forEach($modal => {
                if(!$modal.classList.contains('closed')) {
                    new Modal($modal).close();
                }
            });
        }
    });

});